import { BaseModel } from "@blue-chip/core";

export default class FeeSubScope extends BaseModel {}
